import { ConductorOneChildActive } from "@frui.ts/screens";
import { computed } from "mobx";
import type { Modules } from "../config";
import type LocalizationService from "../services/localizationService";
import type ScreenBase from "@frui.ts/screens/dist/structure/screenBase";
import type { IModuleViewModel } from "./types";

export default abstract class ModuleViewModel<TChild extends ScreenBase>
  extends ConductorOneChildActive<TChild>
  implements IModuleViewModel<TChild>
{
  protected abstract readonly module: Modules;
  protected abstract localizationService: LocalizationService;

  @computed
  get name() {
    return this.translate("name");
  }

  protected findNavigationChild(name?: string) {
    if (!name && !this.activeChild) {
      return this.children[0];
    }

    return super.findNavigationChild(name);
  }

  closeChild() {
    // children cannot be closed
    return false;
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(this.module, code, size);
  }
}
